import { useEffect, useMemo, FC } from 'react';
import { useStore } from 'effector-react';
import { SelectControl, SelectField } from '@ui/index';
import { Data } from '../../interfaces';
import { $data, fxGetList, $isLoading } from '../../models';

interface selectFieldProps {
  form: {
    setFieldValue: (name: string, value: object) => void;
  };
  field: {
    name: string;
  };
  selectedData: number[];
}

const WorkSelect: FC<selectFieldProps> = ({ selectedData = [], ...props }) => {
  const data = useStore($data);
  const isLoading = useStore($isLoading);

  const options = useMemo(() => {
    if (data.length > 0 && selectedData.length > 0) {
      return data.filter(({ id }) => !selectedData.includes(id));
    }
    return data;
  }, [data, selectedData]);

  useEffect(() => {
    fxGetList();
  }, []);

  return (
    <SelectControl
      options={options}
      isLoading={isLoading}
      {...props}
    />
  );
};

const WorkSelectField: FC<selectFieldProps> = (props) => {
  const onChange = (value: Data) => props.form.setFieldValue(props.field.name, value);

  return <SelectField component={<WorkSelect {...props} />} onChange={onChange} {...props} />;
};

export { WorkSelect, WorkSelectField };
